(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/game-guide/game-guide.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/game-guide/game-guide.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const fetchGameGuideArticles = svs.arena.store.gameguide.actions.fetchGameGuideArticles;
const GameGuide = () => {
  const dispatch = ReactRedux.useDispatch();
  const articles = ReactRedux.useSelector(state => {
    var _state$gameguide;
    return (_state$gameguide = state.gameguide) === null || _state$gameguide === void 0 ? void 0 : _state$gameguide.articles;
  }) || [];
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  useEffect(() => {
    svs.arena.logger.debug('GameGuide, useEffect...fetchGameGuideArticles...');
    dispatch(fetchGameGuideArticles());
  }, [dispatch]);
  useEffect(() => {
    if (articles && articles.length > 0) {
      setSelectedItem(articles[0]);
    }
  }, [articles]);
  const changeArticle = (e, item) => {
    const track = {
      category: 'spela-tillsammans',
      action: 'Spelguide_meny',
      opt_label: item.title ? item.title.replace('', '_') : 'Undefined tab'
    };
    svs.components.analytics.trackEvent(track);
    e.preventDefault();
    setSelectedItem(item);
  };


  return React.createElement("div", null, articles && articles.length > 0 && React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true
    ,
    useScrollFaders: true,
    useScrollHelpers: svs.core.detect.formfactor.desktop()
  }, articles.map(item => React.createElement(LinkItem, {
    Component: "a",
    gutter: 1,
    key: item.id,
    label: item.title,
    onClick: e => changeArticle(e, item),
    selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) === item.id
  }))), selectedItem && React.createElement("div", {
    className: "simple-article-content padding-xs-2 padding-md-3 pop-up-box f-content",
    dangerouslySetInnerHTML: {
      __html: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.body
    }
  }));
};
svs.arena.pages.GameGuide = GameGuide;

 })(window);